module.exports = __webpack_public_path__ + "img/9.43a7091b.png";